import { type ReactElement } from 'react'
import { createFileRoute } from '@tanstack/react-router'
import { NotReady, Page } from '@components'
import { QuizPageContainer } from '../quiz_.$quizId/QuizPageContainer'
import { useQuizContext } from '../quiz_.$quizId/context'
import { QuizBasicInfo } from './QuizBasicInfo'

function QuizSummaryRoute(): ReactElement {
  const { quiz, refetch, isFetching } = useQuizContext()
  const { questions } = useQuizContext()

  return (
    <QuizPageContainer>
      <Page.Heading isFetching={isFetching} refetch={refetch} title='Summary' />
      <Page.Content scrollArea>
        <QuizBasicInfo quiz={quiz} questionCount={questions.length} />
      </Page.Content>
    </QuizPageContainer>
  )
}

export const Route = createFileRoute('/quiz_/$quizId/summary/')({
  component: QuizSummaryRoute,
})
